<template>
  <div class="NongliCalendar">
    <div class="main">
      <div class="choose_year">
        <div class="icon" @click="chooseMonth(-1)">
          <i class="fa fa-angle-left">
            <img :src="leftIcon"/>
          </i>
        </div>
        <div class="date">{{year}}年{{month.toString().padStart(2, '0')}}月</div>
        <div class="icon" @click="chooseMonth(1)">
          <i class="fa fa-angle-right">
            <img :src="rightIcon"/></i>
        </div>
      </div>
      <div class="days_area">
        <div class="day week" :index="index" v-for="(week,index) in weeks" :key="week">{{week}}</div>
        <div class="day" @click="chooseThisDay(day.gregorian)" v-for="(day, index) in days" :key="index" :class="day.gregorian === today ? 'choose_day' : ''">
          <p>{{day.gregorian}}</p>
          <span>
            <div :class=" 'shijieri '+(getStringLength(day.shijieri)<=6 ? ' center':'')" v-if="day.shijieri">{{day.shijieri}}</div>

            <div v-else>{{day.lunar}}</div>
          </span>
        </div>
      </div>
  </div>
 </div>
</template>

<script>
  //参考地址 https://blog.csdn.net/qq_32109661/article/details/87794155
  import leftIcon from '@/assets/left.png'
  import rightIcon from '@/assets/right.png'
  export default {
  name: 'NongliCalendar',
  data () {
    return {
      leftIcon: leftIcon,
      rightIcon: rightIcon,
      year: 0,
      month: 0,
      today: 0,
      days: [],
      weeks: ['日', '一', '二', '三', '四', '五', '六']
    }
  },
  mounted () {
    const now = new Date()
    this.year = now.getFullYear()
    this.month = now.getMonth() + 1
    this.today = now.getDate()
    this.getDays()
  },
  methods: {
    getStringLength(val){
      var len = 0
      for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i)
        if (a.match(/[^\x00-\xff]/ig)!== null){
          len += 2;
        } else {
          len += 1
        }
      }
      return len
    },
    getDays () { // 获取当前月份所有公历日期及其农历日期
      this.days = []
      const day = new Date()
      day.setFullYear(this.year, this.month - 1, 1) // 此处较之前调整，获取当月第一天
      const month = new Date()
      month.setFullYear(this.year, this.month, 0) // 此处较之前调整，获取当月
      for (let i = 0; i < day.getDay(); i++) { // 当月第一天距离所在周周一的空白占位
        this.days.push({ gregorian: '', lunar: '', shijieri: '' })
      }
      for (let i = 1; i <= month.getDate(); i++) { // 获取当月天数填充日历
        let shijieri = this.getShiejieri(this.year, this.month, i)
        this.days.push({ gregorian: i, lunar: this.getLunarDay(this.year, this.month, i), shijieri: shijieri })
      }
    },
    chooseYears (state) { // 改变年份
      this.year += state
      this.today = 1
      this.getDays()
    },
    chooseMonth (state) { // 改变月份
      this.month += state
      this.today = 1
      if (this.month < 1) {
        this.month = 12
        this.chooseYears(-1)
      } else if (this.month > 12) {
        this.month = 1
        this.chooseYears(1)
      } else {
        this.getDays()
      }
      let date = this.year+'/'+ this.month.toString().padStart(2, '0')+ '/'+ this.today.toString().padStart(2, '0')
      this.$store.commit('setChooseDay', date)
      this.$store.commit('incrementChooseDay');
    },
    chooseThisDay (day) { // 选择某天，主要是考虑可以当时间选择器用
      if (day > 0) {
        this.today = day
      }
      // console.log(this.year+'/'+this.month+'/'+day)
      let date = this.year+ '/'+ this.month.toString().padStart(2, '0')+ '/'+ day.toString().padStart(2, '0')
      this.$store.commit('setChooseDay', date)
      this.$store.commit('incrementChooseDay');
      this.$store.commit('showSwiper');
    },
    getLunarDay (solarYear, solarMonth, solarDay) { // 拷贝别人又自己调整过的获取农历日期的代码，想要原来的代码估计百度一下就有了
      const madd = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334]
      // const tgString = '甲乙丙丁戊己庚辛壬癸'
      // const dzString = '子丑寅卯辰巳午未申酉戌亥'
      const numString = '一二三四五六七八九十'
      const monString = '正二三四五六七八九十冬腊'
      const CalendarData = [0xA4B, 0x5164B, 0x6A5, 0x6D4, 0x415B5, 0x2B6, 0x957, 0x2092F, 0x497, 0x60C96, 0xD4A, 0xEA5, 0x50DA9, 0x5AD, 0x2B6, 0x3126E, 0x92E, 0x7192D, 0xC95, 0xD4A, 0x61B4A, 0xB55, 0x56A, 0x4155B, 0x25D, 0x92D, 0x2192B, 0xA95, 0x71695, 0x6CA, 0xB55, 0x50AB5, 0x4DA, 0xA5B, 0x30A57, 0x52B, 0x8152A, 0xE95, 0x6AA, 0x615AA, 0xAB5, 0x4B6, 0x414AE, 0xA57, 0x526, 0x31D26, 0xD95, 0x70B55, 0x56A, 0x96D, 0x5095D, 0x4AD, 0xA4D, 0x41A4D, 0xD25, 0x81AA5, 0xB54, 0xB6A, 0x612DA, 0x95B, 0x49B, 0x41497, 0xA4B, 0xA164B, 0x6A5, 0x6D4, 0x615B4, 0xAB6, 0x957, 0x5092F, 0x497, 0x64B, 0x30D4A, 0xEA5, 0x80D65, 0x5AC, 0xAB6, 0x5126D, 0x92E, 0xC96, 0x41A95, 0xD4A, 0xDA5, 0x20B55, 0x56A, 0x7155B, 0x25D, 0x92D, 0x5192B, 0xA95, 0xB4A, 0x416AA, 0xAD5, 0x90AB5, 0x4BA, 0xA5B, 0x60A57, 0x52B, 0xA93, 0x40E95]
      if (!(solarYear < 1921 || solarYear > 2999)) { // 注意看此处限定了年份，设置自己需要的范围即可
        solarMonth = (parseInt(solarMonth) > 0) ? (solarMonth - 1) : 11
        const timeArr = [solarYear, solarMonth, solarDay]
        let TheDate = (timeArr.length !== 3) ? new Date() : new Date(timeArr[0], timeArr[1], timeArr[2])
        let total, m, n, k
        let isEnd = false
        let theDateYear = TheDate.getFullYear()
        total = (theDateYear - 1921) * 365 + Math.floor((theDateYear - 1921) / 4) + madd[TheDate.getMonth()] + TheDate.getDate() - 38
        if (theDateYear % 4 === 0 && TheDate.getMonth() > 1) {
          total++
        }
        for (m = 0; ; m++) {
          k = (CalendarData[m] < 0xfff) ? 11 : 12
          for (n = k; n >= 0; n--) {
            if (total <= this.getBit(CalendarData[m], n)) {
              isEnd = true
              break
            }
            total = total - this.getBit(CalendarData[m], n)
          }
          if (isEnd) {
            break
          }
        }
        let cMonth, cDay // cYear,
        // cYear = 1921 + m
        cMonth = k - n + 1
        cDay = total
        if (k === 12) {
          if (cMonth === Math.floor(CalendarData[m] / 0x10000) + 1) {
            cMonth = 1 - cMonth
          }
          if (cMonth > Math.floor(CalendarData[m] / 0x10000) + 1) {
            cMonth--
          }
        }
        // let run = ''
        let cDayStr = numString.charAt(cDay - 1)
        /* if (cMonth < 1) {
          run = '(闰)'
        } */
        if (cDay % 10 !== 0 || cDay === 10) {
          cDayStr = numString.charAt((cDay - 1) % 10)
        }
        return cDay === 1 ? monString.charAt(cMonth - 1) + '月' : (cDay < 11 ? '初' : (cDay < 20 ? '十' : (cDay < 30 ? '廿' : '三十'))) + cDayStr // tgString.charAt((cYear - 4) % 10) + dzString.charAt((cYear - 4) % 12) + '年 ' + run + monString.charAt(cMonth - 1) + '月' +
      }
    },
    getWeekGroupByYearAndMonth: function(y, m){
      let tempTime = new Date(y, m, 0);
      let time = new Date();
      let zhou0 = []
      let zhou1 = []
      let zhou2 = []
      let zhou3 = []
      let zhou4 = []
      let zhou5 = []
      let zhou6 = []
      for (let i = 1; i <= tempTime.getDate(); i++) {
        time.setFullYear(y, m - 1, i);
        let day = time.getDay();
        switch (day) {
          case 0:zhou0.push(i); break;
          case 1:zhou1.push(i); break;
          case 2:zhou2.push(i); break;
          case 3:zhou3.push(i); break;
          case 4:zhou4.push(i); break;
          case 5:zhou5.push(i); break;
          case 6:zhou6.push(i); break;
        }
      }
      let zhou = []
      zhou.push(zhou0)
      zhou.push(zhou1)
      zhou.push(zhou2)
      zhou.push(zhou3)
      zhou.push(zhou4)
      zhou.push(zhou5)
      zhou.push(zhou6)
      return zhou
    },
    getShiejieri(year, month, day){
      if (month===1 && day===1){
        return '元旦'
      }
      //世界麻风日：每年1月份最后一个星期日
      if (month===1){
        let zhou = this.getWeekGroupByYearAndMonth(year, month)
        let lastSunday = zhou[0].pop()
        // console.log('lastSunday is'+lastSunday)
        if (day===lastSunday){
          return '世界麻风日'
        }
      }
      //国际罕见病日：每年2月份最后一天
      if (month===2){
        let lastDay = new Date(year, month, 0).getDate()
        if (day===lastDay){
          return '国际罕见病日'
        }
      }
      if (month===3 && day===3){
        return '全国爱耳日'
      }
      if (month===3 && day===6){
        return '世界青光眼日'
      }
      if (month===3 && day===8){
        return '妇女节'
      }
      //世界肾脏病日：每年3月份第二个星期四
      if (month===3){
        let zhou = this.getWeekGroupByYearAndMonth(year, month)
        let secondThursday = zhou[4]
        secondThursday.shift()
        secondThursday = secondThursday.shift()
        if (day===secondThursday){
          return '世界肾脏病日'
        }
      }
      if (month===3 && day===17){
        return '中国国医节'
      }
      if (month===3 && day===18){
        return '全国爱肝日'
      }
      if (month===3 && day===21){
        return '世界睡眠日'
      }
      if (month===3 && day===24){
        return '世界防治结核日'
      }

      if (month===4 && day===2){
        return '世界自闭症日'
      }
      if (month===4 && day===7){
        return '世界卫生日'
      }
      if (month===4 && day===11){
        return '世界帕金森病日'
      }
      if (month===4 && day===17){
        return '世界肿瘤日,世界血友病日'
      }
      if (month===4 && day===25){
        return '世界防治疟疾日'
      }
      if (month===5 && day===1){
        return '劳动节'
      }
      if (month===5 && day===5){
        return '碘缺乏病防治日'
      }
      //世界哮喘日：每年5月份第一个星期二
      if (month===5){
        let zhou = this.getWeekGroupByYearAndMonth(year, month)
        let tuesday = zhou[2]
        tuesday = tuesday.shift()
        if (day===tuesday){
          return '世界哮喘日'
        }
      }
      if (month===5 && day===8){
        return '世界红十字日'
      }
      if (month===5 && day===12){
        return '国际护士节'
      }
      if (month===5 && day===18){
        return '全国血管健康日'
      }

      //全国助残日：每年5月份第三个星期日
      if (month===5){
        let zhou = this.getWeekGroupByYearAndMonth(year, month)
        let sunday = zhou[0]
        sunday.shift()
        sunday.shift()
        sunday = sunday.shift()
        if (day===sunday){
          return '全国助残日'
        }
      }
      if (month===5 && day===29){
        return '世界肠道健康日'
      }
      if (month===5 && day===31){
        return '世界禁烟日'
      }
      if (month===6 && day===1){
        return '儿童节'
      }
      if (month===6 && day===6){
        return '世界爱眼日'
      }
      if (month===6 && day===14){
        return '世界献血者日'
      }
      if (month===6 && day===26){
        return '世界禁毒日'
      }
      if (month===7 && day===1){
        return '建党节'
      }
      if (month===7 && day===8){
        return '世界过敏性疾病日'
      }
      if (month===7 && day===11){
        return '世界人口日'
      }
      if (month===7 && day===28){
        return '世界肝炎日'
      }
      if (month===8 && day===1){
        return '建军节'
      }
      if (month===9 && day===20){
        return '世界爱牙日'
      }
      //国际聋人节：每年9月份第四个星期日
      if (month===9){
        let zhou = this.getWeekGroupByYearAndMonth(year, month)
        let sunday = zhou[0]
        sunday.shift()
        sunday.shift()
        sunday.shift()
        sunday = sunday.shift()
        //
        // if (year===2019){
        //   console.log('getWeekGroupByYearAndMonth:year='+year+';month='+month+';zhou='+zhou[0])
        // }
        if (day===sunday){
          return '国际聋人节'
        }
      }
      if (month===9 && day===28){
        return '世界心脏日'
      }
      if (month===10 && day===1){
        return '国庆节,国际老年人日'
      }
      if (month===10 && day===8){
        return '全国高血压日'
      }
      if (month===10 && day===10){
        return '世界精神卫生日'
      }
      if (month===10 && day===11){
        return '世界镇痛日'
      }
      if (month===10 && day===12){
        return '世界关节炎日'
      }
      if (month===10 && day===13){
        return '世界保健日'
      }
      if (month===10 && day===15){
        return '国际肓人节'
      }
      if (month===10 && day===20){
        return '世界骨质疏松日'
      }
      if (month===10 && day===22){
        return '世界传统医药日'
      }
      if (month===10 && day===28){
        return '世界男性健康日'
      }
      if (month===10 && day===29){
        return '世界卒中日,世界银屑病日'
      }
      if (month===11 && day===14){
        return '世界糖尿病日'
      }
      //世界慢性阻塞性肺炎日：每年11月份第三个星期三
      if (month===11){
        let zhou = this.getWeekGroupByYearAndMonth(year, month)
        let wenzday = zhou[3]
        wenzday.shift()
        wenzday.shift()
        wenzday = wenzday.shift()
        //
        // if (year===2019){
        //   console.log('getWeekGroupByYearAndMonth:year='+year+';month='+month+';zhou='+zhou[0])
        // }
        if (day===wenzday){
          return '世界慢性阻塞性肺炎日'
        }
      }

      if (month===12 && day===1){
        return '世界艾滋病日'
      }
      if (month===12 && day===3){
        return '世界残疾人日'
      }
      if (month===12 && day===5){
        return '世界强化免疫日'
      }
      if (month===12 && day===11){
        return '世界防哮喘日'
      }
      return ''
    },
    getBit (m, n) { // 也是拷贝的，不是很明白这段代码干嘛的，不过很明显是处理二进制数据的
      return 29 + ((m >> n) & 1)
    }
  }
};
</script>
<style lang="less" scoped>
  .NongliCalendar{
    .main{
      .choose_year{
        display: flex;
        border-top:1px solid #5cb85c;
        border-bottom: 1px solid #E1E7EF;
        margin-bottom: 3%;
        .icon{
          width: 20%;
          height: 6vh;
          line-height: 6vh;
          text-align: center;
          .fa{
            img{
              margin: 1.5vh 0;
              height: 3vh;
            }
          }
          .fa-angle-double-left{
            .left-double{
              width: 16px;
              height: 16px;
              border-top: 2px solid #5cb85c;
              border-left: 2px solid #5cb85c;
              -webkit-transform: rotate(-45deg);
              transform: rotate(-45deg);
            }

          }
          .fa-angle-left{
            .left-single{
              width: 16px;
              height: 16px;
              border-top: 2px solid #5cb85c;
              border-left: 2px solid #5cb85c;
              -webkit-transform: rotate(-45deg);
              transform: rotate(-45deg);
            }
          }
        }
        .date{
          width: 60%;
          text-align: center;
          height: 6vh;
          line-height: 6vh;
          font-size: 1.2rem;
        }
      }
      .days_area{
        display: flex;
        flex-wrap: wrap;
        padding: 0 1vh;
        .day{
          width: 14.28%;
          text-align: center;
          padding:0.5vh 0;
          margin-top: 1vh;
          p{
            margin: 0;
            font-size: 2.5vh;
          }
          span{
            font-size: 1vh;
            .shijieri{
              text-align: left;
              padding: 0 0 0 1vw;;
            }
            .shijieri.center{
              text-align: center;
            }
          }
        }
        .week{
          background-color: #5cb85c;
          color: #fff;
          font-weight: bold;
          height: 40px;
          line-height: 40px;
          margin: 0;
        }
        .choose_day{
          background-color: #5cb85c;
          color: #fff;
          font-weight: bold;

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NongliCalendar.vue